import B3Request from '../../request/b3Fetch';
import { RequestType } from '../../request/base';

const getCompanyData = (companyId: any) =>
  B3Request.get(`/api/v2/companies/${companyId}`, RequestType.B2BRest);

export default getCompanyData;
